import { client } from "utils";

export const getSourceRequest = () => client.get("source");
